import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { postBootstrap, preBootstrap } from './app';
import { appShellBoot } from './app-shell/app-shell-boot.utility';
import { isAppShell } from './app-shell/is-app-shell.utility';
import { AppModule } from './app.module';
import { onAngularBootstrapError } from './shared/bootstrap/bootstrap-handler';
import { getStartupConfiguration } from './shared/shared-context/client-startup-config.service';
import { unregisterAndReload } from './shared/utilities/unregister-and-reload.utility';

try {
    // This flag is meant to indicate that the app bundle was successfully parsed. This is checked in AuthHead.cshtml.
    window.ohpAppBundleParsingSuccessFlag = true;

    const doBootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule, {
            // Needed for JiT Compilation to remove Whitespaces
            preserveWhitespaces: false
        });

    // App Shell boot flow
    if (isAppShell()) {
        appShellBoot().then(doBootstrap).then(postBootstrap).catch(unregisterAndReload);
    } else {
        // Regular page bootstrap.
        preBootstrap();

        // Angular 2 JiT Application Bootstrap.
        doBootstrap()
            .then(postBootstrap)
            .catch(ex => onAngularBootstrapError(ex, getStartupConfiguration()));
    }
} catch (ex) {
    isAppShell() ? unregisterAndReload() : onAngularBootstrapError(ex, getStartupConfiguration());
}
